<div class="orders-page">
    <br />
    <h3 class="orders-title">{{ 'Ordrar' | translate }}</h3>
    <div class="review-mode-banner" *ngIf="globals.storeSettings.reviewMode">
        <span class="material-symbols-outlined">science</span>
        <div>
            <strong>{{ 'Shopify review mode' | translate }}</strong>
            <p>{{ globals.storeSettings.reviewModeCredits | number:'1.0-2' }} {{ 'test credits remain. The actions below simulate production safely; no order is sent to a physical print partner.' | translate }}</p>
        </div>
    </div>
    <div class="row orders-filters">
        <div class="col">
            <div *ngIf="globals.currentUser">
                <mat-form-field appearance="fill" class="fullwidth">
                    <mat-label>{{ 'Period' | translate }}</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate [placeholder]="'Startdatum' | translate" (dateChange)="orderNumberKeyUp()" [(ngModel)]="periodStart">
                        <input matEndDate [placeholder]="'Slutdatum' | translate" (dateChange)="orderNumberKeyUp()" [(ngModel)]="periodEnd">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>
        <div class="col">
            <mat-form-field class="fullwidth">
                <mat-label>{{ 'Ordernummer' | translate }}</mat-label>
                <input matInput type="text" (keyup)="orderNumberKeyUp()" [(ngModel)]="orderNumber" />
            </mat-form-field>
        </div>
        <div class="col align-right">
            <mat-form-field class="fullwidth">
                <mat-label>{{ 'Statusar' | translate }}</mat-label>
                <mat-select multiple [(ngModel)]="statuses" (closed)="fetchOrders()">
                    <mat-option [value]="'PENDING'">{{ 'Behandlas' | translate }}</mat-option>
                    <mat-option [value]="'READY'">{{ 'Redo' | translate }}</mat-option>
                    <mat-option [value]="'QUEUED_FOR_PRINT'">{{ 'Skickad till print' | translate }}</mat-option>
                    <mat-option [value]="'PRINTED'">{{ 'Printad' | translate }}</mat-option>
                    <mat-option [value]="'SHIPPED'">{{ 'Skickad' | translate }}</mat-option>
                    <mat-option [value]="'DELIVERED'">{{ 'Levererad' | translate }}</mat-option>
                    <mat-option [value]="'CANCELLED'">{{ 'Avbruten' | translate }}</mat-option>
                    <mat-option [value]="'ERROR'">{{ 'Fel' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row orders-table-section">

        <div class="col-12">
            <table class="fullwidth styled orders-table">
                <tr>
                    <th>#</th>
                    <th>{{ 'Namn' | translate }}</th>
                    <th>{{ 'Produkter' | translate }}</th>
                    <th class="align-right">{{ 'Skapad' | translate }}</th>
                    <th class="align-right">{{ 'Status' | translate }}</th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                <ng-container *ngFor="let order of orders">
                    <tr class="order-table-row" [ngClass]="{'sandbox-order': isSandboxOrder(order)}">
                        <td class="valign-top">
                            <div class="sandbox-badge" *ngIf="isSandboxOrder(order)" [title]="'Sandboxorder – skickas aldrig till tryck' | translate">
                                <span class="material-symbols-outlined">science</span>{{ 'Sandbox' | translate }}
                            </div>
                            <div class="sandbox-badge frozen-badge" *ngIf="globals.userIsAce() && order.isFrozen" [title]="'Fryst order – behandlas inte' | translate">
                                <span class="material-symbols-outlined">ac_unit</span>{{ 'Fryst' | translate }}
                            </div>
                            <!-- LEGACY -->
                            <div *ngIf="!globals.currentUser">
                                <div *ngIf="!order.metadata || !order.metadata.reclaimNewOrderNumber">
                                    {{order.orderNumber}}
                                </div>
                                <div class="reclaim-order-number" *ngIf="order.metadata && order.metadata.reclaimNewOrderNumber">
                                    <div class="striked negative-color">{{order.orderNumber}}</div>
                                    <div>{{order.metadata.reclaimNewOrderNumber}}</div>
                                </div>
                            </div>


                            <div *ngIf="globals.currentUser">
                                <div *ngIf="!order.metadata || !order.metadata.reclaimNewOrderNumber">
                                    <a [href]="globals.storeUrl('/poster-orders/' + order._id, globals.storeSettings._id, true)"
                                        target="_blank">{{order.orderNumber}}</a>
                                </div>
                                <div class="reclaim-order-number" *ngIf="order.metadata && order.metadata.reclaimNewOrderNumber">
                                    <div class="striked negative-color"><a
                                            [href]="globals.storeUrl('/poster-orders/' + order._id, globals.storeSettings._id, true)"
                                            target="_blank">{{order.orderNumber}}</a></div>
                                    <div><a
                                            [href]="globals.storeUrl('/poster-orders/' + order.metadata.reclaimNewOrderId, globals.storeSettings._id, true)"
                                            target="_blank">{{order.metadata.reclaimNewOrderNumber}}</a></div>
                                </div>
                            </div>

                            <div class="partner-store-admin-color small-text" *ngIf="globals.userIsAce() && order.thirdParty && order.thirdParty.texPrint && order.thirdParty.texPrint.order">
                                (Texprint: {{order.thirdParty.texPrint.order.id}})
                            </div>

                        </td>
                        <td class="valign-top">
                            <span *ngIf="order.shippingInfo">
                                {{order.shippingInfo.firstName}} {{order.shippingInfo.lastName}}
                            </span>
                        </td>
                        <td class="valign-top">
                            <table class="fullwidth styled">
                                <tr *ngFor="let item of order.items">
                                    <td class="align-center">
                                        <div class="mockup-image" *ngIf="item.mockupImageUrl">
                                            <img [src]="item.mockupImageUrl" />
                                        </div>
                                        {{item.quantity}}x
                                    </td>
                                    <td>
                                        <!-- LEGACY -->
                                        <div *ngIf="!globals.currentUser">
                                            (
                                            <span *ngIf="item.status == 'UNKNOWN'">{{ 'Okänd' | translate }}</span>
                                            <span *ngIf="item.status == 'AWAITING_PRINT_FILE'">{{ 'Tryckfil saknas' | translate }}</span>
                                            <span *ngIf="item.status == 'PENDING_POSTER'">{{ 'Behandlar produkt' | translate }}</span>
                                            <span *ngIf="item.status == 'READY'">{{ 'Redo' | translate }}</span>
                                            )
                                            {{item.name}} <span *ngIf="item.size"> - {{item.size}}</span>
                                            <div class="row">
                                                <div class="col" *ngIf="item.thirdParty && item.thirdParty.pictufy">{{ 'Pictufy-ID:' | translate }}<a href="https://pictufy.com/view/{{item.thirdParty.pictufy.artworkId}}/artwork"
                                                        target="_blank">{{item.thirdParty.pictufy.artworkId}}</a>
                                                </div>
                                                <div class="col" *ngIf="item.posterId">
                                                    <a [routerLink]="[globals.panelUrl('/posters/' + item.posterId)]" target="_blank">{{ 'Produkt' | translate }}</a>
                                                </div>
                                            </div>

                                            <!-- AWAITING PRINT FILE -->
                                            <div *ngIf="item.status == 'AWAITING_PRINT_FILE' && order.status == 'PENDING' && !item.isStockItem">
                                                <file-uploader
                                                    [uploadUrl]="'/poster-orders/' + order._id + '/items/' + item.identifier + '/add-print-file?useAsPrintFile=' + item.useAsPrintFile"
                                                    [customText]="'Släpp tryckfil här' | translate" (fileUploaded)="printFileAdded(order, item, $event)">
                                                </file-uploader>
                                                <p *ngIf="globals.storeSettings.reviewMode" class="review-mode-hint">
                                                    {{ "Since you're in review mode, you can just drop a random image here and wait for it to be processed before continuing the order simulation." | translate }}
                                                </p>
                                                <div>
                                                    <mat-checkbox [(ngModel)]="item.useAsPrintFile" color="primary">{{ 'Använd som tryckfil utan att skala om (endast PDF)' | translate }}</mat-checkbox>
                                                </div>

                                                <div *ngIf="item.printFileUrl">
                                                    <br />
                                                    <div class="row">
                                                        <div class="col">
                                                            <a href="{{item.printFileUrl}}" target="_blank">{{ 'Föreslagen tryckfil' | translate }}</a>
                                                        </div>
                                                        <div class="col align-right">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <button mat-raised-button class="styled slim" color="primary"
                                                                        (click)="acceptPrintFile(order, item, false)">{{ 'Godkänn denna' | translate }}</button>
                                                                </div>
                                                                <div class="col">
                                                                    <button mat-raised-button class="styled slim" color="primary"
                                                                        (click)="acceptPrintFile(order, item, true)">{{ 'Godkänn permanent' | translate }}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>

                                            <!-- UNKNOWN -->
                                            <div *ngIf="item.status == 'UNKNOWN' && item.itemInfo">
                                                <div class="row">
                                                    <div class="col-auto">
                                                        <mat-form-field class="">
                                                            <mat-label>{{ 'Typ' | translate }}</mat-label>
                                                            <mat-select [(ngModel)]="item.itemInfo.posterType"
                                                                (selectionChange)="posterTypeChanged(order, item)">
                                                                <mat-option [value]="'POSTER'">{{ 'Poster' | translate }}</mat-option>
                                                                <mat-option [value]="'CANVAS'">{{ 'Canvas' | translate }}</mat-option>
                                                                <!--  <mat-option [value]="'TSHIRT'">{{ 'T-Shirt' | translate }}</mat-option> -->
                                                                <mat-option [value]="'CLOTHES'">{{ 'Kläder' | translate }}</mat-option>
                                                                <mat-option [value]="'STOCK_ITEM'">{{ 'Stock Item' | translate }}</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col">
                                                        <mat-form-field class="fullwidth">
                                                            <mat-label>SKU</mat-label>
                                                            <mat-select [(ngModel)]="item.itemInfo.sku" (selectionChange)="skuChanged(order, item)">
                                                                <mat-option
                                                                    *ngFor="let skuInfo of availableSkuInfoByPosterType[item.itemInfo.posterType]"
                                                                    [value]="skuInfo.sku">{{skuInfo.sku}}</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col">
                                                        <button mat-raised-button class="styled slim fullwidth" color="primary"
                                                            (click)="addOrderItemInfo(order, item)">{{ 'Spara' | translate }}</button>
                                                    </div>
                                                    <div class="col">
                                                        <button mat-raised-button class="styled slim fullwidth" color="warn"
                                                            (click)="deleteOrderItem(order, item)">{{ 'Ta bort' | translate }}</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div *ngIf="globals.currentUser">
                                            <order-item-administration [item]="item" [order]="order"></order-item-administration>
                                        </div>
                                    </td>
                                </tr>

                                <tr class="add-order-item-row" *ngIf="['PENDING', 'READY'].includes(order.status)">
                                    <td colspan="2">
                                        <button mat-raised-button class="styled slim fullwidth" color="primary"
                                            (click)="addOrderItem(order)">{{ 'Lägg till produkt' | translate }}</button>
                                    </td>
                                </tr>

                            </table>
                            <div>


                            </div>
                        </td>
                        <td class="align-right valign-top">{{order.created | date : 'yyyy-MM-dd HH:mm'}}</td>

                        <td class="align-right valign-top">
                            <ng-container *ngIf="storeHasFreezeTime">
                                <span *ngIf="isInFreezeTime(order.created)"
                                    class="material-symbols-outlined partner-color valign-middle freeze-icon">schedule</span>
                            </ng-container>


                            <span *ngIf="order.status == 'PENDING'">{{ 'Behandlas' | translate }}</span>
                            <span *ngIf="order.status == 'READY'">{{ 'Redo' | translate }}</span>
                            <span *ngIf="order.status == 'QUEUED_FOR_PRINT'">{{ 'Skickad till print' | translate }}</span>
                            <span *ngIf="order.status == 'PRINTED'">
                                <div *ngIf="order.productionConfirmed">{{ 'Printad' | translate }}</div>
                                <div *ngIf="!order.productionConfirmed">{{ 'Inväntar print' | translate }}</div>
                            </span>
                            <span *ngIf="order.status == 'SHIPPED'">{{ 'Skickad' | translate }}</span>
                            <span *ngIf="order.status == 'DELIVERED'">{{ 'Levererad' | translate }}</span>
                            <span *ngIf="order.status == 'CANCELLED'">{{ 'Avbruten' | translate }}</span>
                            <span *ngIf="order.status == 'ERROR'">{{ 'Fel' | translate }}</span>

                            <div class="shopify-sync-details" *ngIf="order.thirdParty && order.thirdParty.shopify">
                                <span>Payment: {{order.thirdParty.shopify.webhookOrder?.financial_status || order.thirdParty.shopify.order?.financial_status || (order.isPaid ? 'paid' : 'pending')}}</span>
                                <span>Shopify fulfillment: {{order.thirdParty.shopify.webhookOrder?.fulfillment_status || order.thirdParty.shopify.order?.fulfillment_status || 'unfulfilled'}}</span>
                                <span *ngIf="order.metadata?.voecData?.useVoec">{{ voecSummary(order) }}</span>
                                <span *ngIf="order.metadata?.shopifyLastSyncAt">Last sync: {{order.metadata.shopifyLastSyncAt | date : 'yyyy-MM-dd HH:mm:ss'}}</span>
                                <span class="sync-error" *ngIf="order.metadata?.shopifySyncError">{{order.metadata.shopifySyncError}}</span>
                            </div>
                            <div class="shopify-sync-details" *ngIf="!order.thirdParty?.shopify && order.metadata?.voecData?.useVoec">
                                <span>{{ voecSummary(order) }}</span>
                            </div>
                        </td>
                        <td class="valign-top">
                            <span *ngIf="globals.userIsAce()" class="material-symbols-outlined partner-store-admin-color clickable"
                                (click)="order.showLog = true">list</span>
                        </td>
                        <td class="valign-top">
                            <div *ngIf="order.thirdParty && order.thirdParty.exakta && order.thirdParty.exakta.trackingInfo">
                                <a href="{{order.thirdParty.exakta.trackingInfo.trackingUrl}}" target="_blank"><span
                                        class="material-symbols-outlined partner-color old-shipping-icon">local_shipping</span></a>
                            </div>

                            <ng-container *ngIf="order.shippingDispatches">
                                <ng-container *ngFor="let dispatch of order.shippingDispatches">
                                    <a href="{{dispatch.trackingUrl}}" target="_blank"><span
                                            [ngClass]="{'delivered': dispatch.delivered, 'returned': dispatch.returned}"
                                            class="material-symbols-outlined partner-color shipping-icon">local_shipping</span></a>
                                </ng-container>
                            </ng-container>

                        </td>
                        <td class="valign-top">
                            <div class="review-mode-actions"
                                *ngIf="globals.storeSettings.reviewMode && order.thirdParty && order.thirdParty.shopify">
                                <div class="review-actions-pending" *ngIf="order.status == 'PENDING'">
                                    <span class="material-symbols-outlined">schedule</span>
                                    <div>
                                        <strong>{{ 'Review actions are coming next' | translate }}</strong>
                                        <p>{{ 'This order is still processing. The manual review actions will appear here automatically when every product is ready. Upload or approve any missing print files to continue.' | translate }}</p>
                                    </div>
                                </div>
                                <button class="styled slim fullwidth review-simulation-button" *ngIf="order.status == 'READY'"
                                    [disabled]="reviewActionOrderId == order._id" mat-raised-button color="primary"
                                    (click)="runReviewAction(order, 'submit')">
                                    <span class="material-symbols-outlined">science</span>
                                    <span class="review-action-copy">
                                        <span class="review-action-kicker">{{ 'Review simulation' | translate }}</span>
                                        <span>{{ 'Submit test' | translate }}</span>
                                    </span>
                                </button>
                                <button class="styled slim fullwidth review-simulation-button" *ngIf="order.status == 'QUEUED_FOR_PRINT'"
                                    [disabled]="reviewActionOrderId == order._id" mat-raised-button color="primary"
                                    (click)="runReviewAction(order, 'produce')">
                                    <span class="material-symbols-outlined">science</span>
                                    <span class="review-action-copy">
                                        <span class="review-action-kicker">{{ 'Review simulation' | translate }}</span>
                                        <span>{{ 'Simulate print' | translate }}</span>
                                    </span>
                                </button>
                                <button class="styled slim fullwidth review-simulation-button" *ngIf="order.status == 'PRINTED'"
                                    [disabled]="reviewActionOrderId == order._id" mat-raised-button color="primary"
                                    (click)="runReviewAction(order, 'fulfill')">
                                    <span class="material-symbols-outlined">science</span>
                                    <span class="review-action-copy">
                                        <span class="review-action-kicker">{{ 'Review simulation' | translate }}</span>
                                        <span>{{ 'Sync test fulfillment' | translate }}</span>
                                    </span>
                                </button>
                                <p class="review-action-error" *ngIf="order.reviewActionError">{{order.reviewActionError}}</p>
                            </div>

                            <button class="styled slim fullwidth" *ngIf="['PENDING', 'READY', 'ERROR'].includes(order.status)"
                                mat-raised-button color="primary" (click)="cancelOrder(order)">{{ 'Avbryt order' | translate }}</button>

                            <ng-container *ngIf="globals.currentUser && globals.userIsAce()">
                                <button class="styled slim fullwidth" *ngIf="!order.metadata || !order.metadata.reclaimNewOrderNumber"
                                    [routerLink]="[globals.panelUrl('/reclaim-order/' + order._id)]" mat-raised-button color="primary">{{ 'Reklamera' | translate }}</button>
                            </ng-container>

                            <ng-container *ngIf="globals.currentUser && !globals.userIsAce()">
                                <button class="styled slim fullwidth" *ngIf="!['PENDING', 'READY'].includes(order.status)"
                                    [routerLink]="[globals.panelUrl('/reclaim-order/' + order._id)]" mat-raised-button color="primary">{{ 'Hantera kundreklamation' | translate }}</button>

                                <a href="mailto:info@aceprintpartner.com?subject=Reklamation%20av%20order%20{{order.orderNumber}}"
                                    *ngIf="!['PENDING', 'READY'].includes(order.status)">
                                    <button class="styled slim fullwidth" mat-raised-button color="primary">{{ 'Reklamera till ACE' | translate }}</button>
                                </a>

                            </ng-container>


                        </td>
                    </tr>
                    <tr *ngIf="order.showLog">
                        <td colspan="6">
                            <table class="fullwidth styled log">
                                <tr *ngFor="let logItem of order.log" class="log-item {{logItem.severity}}">
                                    <td>{{logItem.created | date : 'yyyy-MM-dd HH:mm'}}</td>
                                    <td>{{logItem.message}}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </ng-container>

            </table>
        </div>
    </div>
</div>
